import React, { createContext, useState } from "react";

export const StateContext = createContext(undefined);
export const StateDispatchContext = createContext(undefined);

//This if for ignores a specific module on NPM
const getIgnoreFlags = () => {
  if (!window.consoleConfig || !window.consoleConfig.ignoreModules) {
    return [];
  }

  return window.consoleConfig.ignoreModules.replace("-", " ").split(",");
};

export const StateProvider = ({ children }) => {
  //This is the app's global state object. It can be imported and controlled anywhere in the app through the context API
  const [state, setState] = useState({
    isSidebarOpen: false,
    theme: window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light",
    ignoreModules: getIgnoreFlags(),
    oidcUri: JSON.parse(localStorage.getItem("oidcUri")),
    clientId: JSON.parse(localStorage.getItem("clientId")),
    isLoggedIn: JSON.parse(localStorage.getItem("isLoggedIn")),
    connectToWeaviateURI: JSON.parse(localStorage.getItem("connectToWeaviateURI")) || "",
    isWeaviateAuthenticated: JSON.parse(localStorage.getItem("isWeaviateAuthenticated")),
    isWeaviateSelfHosted: JSON.parse(localStorage.getItem("isWeaviateSelfHosted")),
    currentModule: JSON.parse(localStorage.getItem("currentModule")),
    isWeaviateURIDisconnected: true,
    isLoginLoading: false,
    isLogInSelfHostedIncorrect: false,
    metricsDisplay: "Requests (int.)",
    chartJsMonth: "current",
    schema: {
      isComingSoonPageDisplayed: false,
      isAddClassPageDisplayed: false,
      schemaUpdate: false,
    },
    isBrowserProtocolModalOpen: false,
    keepCurrentProtocol: false,
  });

  return (
    <StateContext.Provider value={state}>
      <StateDispatchContext.Provider value={setState}>{children}</StateDispatchContext.Provider>
    </StateContext.Provider>
  );
};
